import { render, staticRenderFns } from "./RuleGroups.vue?vue&type=template&id=3f1fe0d7&scoped=true&"
import script from "./RuleGroups.vue?vue&type=script&lang=js&"
export * from "./RuleGroups.vue?vue&type=script&lang=js&"
import style0 from "./RuleGroups.vue?vue&type=style&index=0&id=3f1fe0d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1fe0d7",
  null
  
)

export default component.exports